import React,{Component} from 'react';
import './dashboard.css'
import {Card} from 'semantic-ui-react'
import { Col, Row, Fade } from 'reactstrap';
import Cookies from "js-cookie";
import axiosVisitor from "../../../axios/axios_visitortag";
import * as common from "../../../const/Common/CommonFunc";
import PlaceHolder from "../../../components/PlaceHolder/PlaceHolder";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import apiConfig from "../../../axios/axios_api_services";

let date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

class App extends Component{

  state = {
    spin:true,
    dashboards: []
  };

  getAllDashboards = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitor.get(apiConfig.CORPORATE_DASHBOARD(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            dashboards: response.data.dashboardCards,
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDashboards();
        }
      });
  };

  componentDidMount(){
    this.getAllDashboards();
  }

  render() {
    const {dashboards} = this.state;

    return (
      <div className="animated fadeIn">
        <Row>

          {
            dashboards.length !== 0 ?
              dashboards.map((element, index) => (

                <Col className={"marginBottom"} key={index} sm={12} md={12} lg={4} xl={4}>
                  <Card
                    fluid
                    color={"orange"}
                    link
                    header={element.name}
                    meta={"Number Of All  "+element.name}
                    description={element.count}
                    extra={date}

                  />
                </Col>
              ))
              : <PlaceHolder data={[1,2,3]}/>
          }

        </Row>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  custom_visitors_list: state.reception_SheduleMeetingReducer.custom_visitors_list,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

